<template>
    <b-image :src='$t("TermsAndConditionPath")'/>
</template>